<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>Manager Info</h3>
                       <v-simple-table>
                           <tbody>
                           <tr v-if="asyncActType=='U'">
                               <th class="listHeader tableLinerT" style="width:20%">Manager ID</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">{{modUsrID}}</td>
                               <th class="listHeader tableLinerT" style="width:20%">National</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%"><v-select style="font-size:13px;" class="align-self-center" v-model="COUNTRY_CODE" :items="countryList" item-text="info" item-value="vals" label="Country" outlined dense single-line hide-details></v-select></td>
                           </tr>
                           <tr v-if="asyncActType=='C'">
                               <th class="listHeader tableLinerT" style="width:20%">Manager ID</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">
                                   <div class="d-flex text-left pa-0  align-self-center">
                                   <v-text-field v-model="USR_ID" outlined dense single-line  small placeholder="ID" hide-details  minlength="4" maxlength="12"></v-text-field>
                                  <v-btn color="grey lighten-2 " small class="ml-1 mt-1"  @click="chkMngID()">check</v-btn>
                                   </div>
                               </td>
                               <th class="listHeader tableLinerT" style="width:20%">National</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%"><v-select style="font-size:13px;" class="align-self-center" v-model="COUNTRY_CODE" :items="countryList" item-text="info" item-value="vals" label="Country" outlined dense single-line hide-details></v-select></td>
                           </tr>
                           <tr>
                               <th class="listHeader tableLinerB">Name</th>
                               <td class="text-left pl-5 tableLinerB"><v-text-field v-model="USR_NM" outlined dense single-line hide-details small placeholder="Name"></v-text-field></td>
                               <th class="listHeader tableLinerB" >Phone</th>
                               <td class="text-left pl-5 tableLinerB"><v-text-field v-model="PHONE" outlined dense single-line hide-details small placeholder="Phone"></v-text-field></td>
                           </tr>
                           <tr >
                               <th class="listHeader tableLinerB">Password</th>
                               <td class="text-left pl-5 tableLinerB"><v-text-field v-model="USR_PWD" outlined dense single-line hide-details small placeholder="Password" maxlength="12" minlength="9"></v-text-field></td>
                               <th class="listHeader tableLinerB" >Password Confirm</th>
                               <td class="text-left pl-5 tableLinerB"><v-text-field v-model="USR_PWD_RE" outlined dense single-line hide-details small placeholder="Pasword confirm" maxlength="12" minlength="9"></v-text-field></td>
                           </tr>
                           <tr>
                               <th class="listHeader tableLinerB">Department</th>
                               <td class="text-left pl-5 tableLinerB"><v-text-field v-model="DEPARTMENT" outlined dense single-line hide-details small placeholder="Department"></v-text-field></td>
                               <th class="listHeader tableLinerB" >Posistion</th>
                               <td class="text-left pl-5 tableLinerB"><v-text-field v-model="POSITION" outlined dense single-line hide-details small placeholder="Position"></v-text-field></td>
                           </tr>
                           <tr>
                               <th class="listHeader tableLinerB">Level</th>
                               <td class="text-left pl-5 tableLinerB"><v-select style="font-size:13px;" class="align-self-center" v-model="AUTH_LEVEL" :items="authLevelList" item-text="info" item-value="vals" label="Level" outlined dense single-line hide-details></v-select></td>
                               <th class="listHeader tableLinerB" >Status</th>
                               <td class="text-left pl-5 tableLinerB"><v-select style="font-size:13px;" class="align-self-center" v-model="USR_STATUS" :items="usrStatusList" item-text="info" item-value="vals" label="Status" outlined dense single-line hide-details></v-select></td>
                           </tr>
                           
                           </tbody>
                       </v-simple-table>
                   
                        <div class="mt-10">
                            <div class="d-flex justify-space-between dense pa-0 ">
                                <div class="pa2 " >
                                    <v-btn dark class="backBtn px-5" @click="goBack" >Back</v-btn>
                                </div>
                                
                                <div class="pa2 ">
                                    <!--
                                    <v-btn color="red lighten-2" small dark class="ml-2 px-5">Delete</v-btn> -->
                                    <v-btn dark class="registerBtn ml-2 px-6" @click="regInfo()">Save</v-btn>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

        <!-- Alert Dialog / Save -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="alertFlag" width="450" >
                <v-card>
                    <v-card-title class=" pb-0  " style="width:450px;">
                        <table>
                            <tr>
                                <td>
                                    <v-icon  style='color:red;'>mdi-alert </v-icon>
                                </td>
                                <td>
                                    <div class="pl-2">{{alertText}}</div>
                                </td>
                            </tr>
                        </table>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="alertFlag = false;regFlag='Y'">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncSuccess-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="goList">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="asyncErrors=false;">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'

export default {
    name: 'MemberDetail',
    components: { Gnb, Footer, PageCrumbs,  Navs, },
    data () {
        return {
            // login Info
            gnbCode:"9", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:12, 
            // Page Title & Breadcrumbs
            pTitles: "New Registration",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Setup', disabled: true,}, { text: 'User Management', disabled: true,}, { text: 'New Registration', disabled: false,}],
            NavList: [ 
                        { title: 'User Management', nums: '1',
                            items: [ { title: 'List', nums:11, href:'/Manager', icons:'mdi-format-list-bulleted' }
                                    , { title: 'New Registration', nums:12, href:'/ManagerWrite' , icons:'mdi-lead-pencil' }
                                    ],
                        },
                    ],    

            modUsrID:'',      

            USR_ID: "", USR_NM:"", DEPARTMENT:"", POSITION:"", HP:"", EMAIL:"",  
            PHONE:"", AUTH_LEVEL:"", USR_STATUS:"", INS_DTM:"", INS_USR_ID:"",    USR_PWD:"", USR_PWD_RE:"", 
            COUNTRY_CODE: "",
            usrStatusList:[{info:'Disable',vals:1}, {info:'Enable',vals:2}],
            authLevelList:[{info:'1',vals:1}, {info:'2',vals:2},{info:'3', vals:3},{info:'4', vals:4},{info:'5', vals:5},{info:'6', vals:6},{info:'7', vals:7},{info:'8', vals:8},{info:'9', vals:9},{info:'10', vals:10}],
            countryList:[{info: 'Indonesia', vals: "ID"}, {info: 'korea', vals: "KR"}], 
            emptyFlag: false, asyncActType:"C",
            show3: false, chkidFlag:false, alertText:"",alertFlag:false, asyncSuccess:false, asyncErrors:false,
       
      idRules: [
        v => !!v || 'ID is required',
        v => v.length >= 4 || 'The minimum length of ID must exceed 4',
        v => v.length < 12 || 'The maximum length of ID must exceed 12',
      ],
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.modMngID);
        this.modUsrID = this.$route.params.modMngID;
        this.asyncActType = this.$route.params.asyncActType;
        if(this.modUsrID == '' || this.modUsrID == undefined) {
            this.modUsrID = localStorage.getItem("modMngID");
            
        }
       
        if(this.modUsrID != '' && this.modUsrID != undefined) {
            this.getInfo();
            //this.getHistory();

            this.navCode2 = 11;
            this.pTitles = "Edit";
            this.pCrumbs = [ { text: 'Home', disabled: true,}, { text: 'Setup', disabled: true,}, { text: 'User Management', disabled: true,}, { text: 'List', disabled: true,}, { text: 'Detail', disabled: false,}];
        } else {
            this.pTitles = "New Registration";
            this.pCrumbs = [ { text: 'Home', disabled: true,}, { text: 'Setup', disabled: true,}, { text: 'User Management', disabled: true,}, { text: 'New Registration', disabled: false,}];
        }
        window.scrollTo(0, 0);
    },

    methods : {
        goList() {
            this.$router.push({ name: 'Manager'});
        },
        
        // API Async 
        getInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "modUsrID": this.modUsrID
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/Manager.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                if(json.result == "success") {
                    this.USR_NM = json.USR_NM; this.COUNTRY_CODE = json.COUNTRY_CODE;
                    this.EMIAL = json.EMIAL; 
                    this.HP = json.HP; this.PHONE = json.PHONE;
                    this.DEPARTMENT = json.DEPARTMENT; this.POSITION = json.POSITION; 
                    this.AUTH_LEVEL = Number(json.AUTH_LEVEL); this.USR_STATUS = Number(json.USR_STATUS); 
                    this.INS_DTM = json.INS_DTM;
                    this.INS_USR_ID = json.INS_USR_ID;
                    this.emptyFlag = false;
                } else {
                    this.emptyFlag = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'Manager'});
        },

        editInfo() {
            this.$router.push({ name: 'ManagerWrite', params: { modMngID: this.modUsrID }})
        },

        alertToForm(arg1, arg2) {
            var str1 = "enter";
            var strInfo1 = "Please"; var strInfo2 = "information";
            if(arg1 == 2) str1 = 'select';
            if(arg1 < 9) {
                this.alertText = strInfo1 +' '+ str1 +' '+ arg2 +' '+ strInfo2+".";
            } else {
                 this.alertText = arg2;
            }
            // Please select country information 
        },

        chkMngID() {
            if(this.USR_ID == '') {
                this.alertFlag=true;
                this.alertToForm('9', 'ID is required');
                return;
            }  
            if(this.USR_ID.length < 4) {
                this.alertFlag=true;
                this.alertToForm('9', 'The minimum length of ID must exceed 4');
                return;
            }  

            const reg = /^[a-zA-Z]+[a-zA-Z0-9]{4,12}$/;
            if (!this.USR_ID.match(reg)) {
                this.alertFlag=true;
                this.alertToForm('9', 'ID can be from 4 to 12 characters in English or English + numbers.');
                return;
            }

            if(this.USR_ID.length > 12) {
                this.alertFlag=true;
                this.alertToForm('9', 'The maximum length of ID must exceed 12');
                return;
            }  
          
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": this.USR_ID})
            };
            
            fetch('https://api.e3bss.com/_APP/POC/chkUsrID.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                if(json.result == "success") {
                    alert("Available ID");
                    this.chkidFlag = true;
                } else {
                    alert("Not Available ID");
                    this.chkidFlag = false;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
                
        }, 

        // API Async 
        regInfo() {
            if(this.asyncActType=="C") {
                if(this.USR_ID == '') {
                    this.regFlag='N'; this.alertFlag=true;
                    this.alertToForm('1', 'Manager ID');
                    return;
                } else {
                    if(!this.chkidFlag) {
                        this.regFlag='N'; this.alertFlag=true;
                        this.alertToForm('1', 'Manager ID ');
                        return;
                    }
                }
            } 
            if(this.USR_NM == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Name');
                return;
            } 
            if(this.PHONE == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'PHONE');
                return;
            }   
            if(this.USR_PWD != '' && (this.USR_PWD != this.USR_PWD_RE)) {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Password');
                return;
            }        
            if(this.DEPARTMENT == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'DEPARTMENT');
                return;
            }     
            if(this.POSITION == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'POSITION');
                return;
            }      
                           
     
            if(this.AUTH_LEVEL == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Level');
                return;
            } 

            if(this.USR_STATUS == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Status');
                return;
            }  
            /*       
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": this.asyncActType
                    , "modUsrID": this.modUsrID
                    , "USR_ID": this.USR_ID
                    , "USR_PWD": this.USR_PWD
                    , "USR_NM": this.USR_NM
                    , "DEPARTMENT": this.DEPARTMENT
                    , "POSITION": this.POSITION
                    , "HP": this.HP
                    , "EMAIL": this.EMAIL
                    , "PHONE": this.PHONE
                    , "AUTH_LEVEL": this.AUTH_LEVEL
                    , "USR_STATUS": this.USR_STATUS
                    , "COUNTRY_CODE": this.COUNTRY_CODE
                }))    
            */            
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": this.asyncActType
                    , "modUsrID": this.modUsrID
                    , "USR_ID": this.USR_ID
                    , "USR_PWD": this.USR_PWD
                    , "USR_NM": this.USR_NM
                    , "DEPARTMENT": this.DEPARTMENT
                    , "POSITION": this.POSITION
                    , "HP": this.HP
                    , "EMAIL": this.EMAIL
                    , "PHONE": this.PHONE
                    , "AUTH_LEVEL": this.AUTH_LEVEL
                    , "USR_STATUS": this.USR_STATUS
                    , "COUNTRY_CODE": this.COUNTRY_CODE
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/Manager.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                if(json.result == "success") {
                   this.asyncSuccess =true;
                    this.asyncErrors = false;
                } else {
                    this.asyncSuccess = false;
                    this.asyncSuccess = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },


    }

}
</script>
